export const environment = {
  production: true,
  sendMandateToBankClientId: '61c031289be21a5fbc23d069',
  sendMandateToNationalEnforcementClientId: '6780f12d38efd58480ae6a6a',
  connectFrontendUrl: 'https://connect.rantalainen.fi',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.
